<template>
  <div>
    <vs-card>
      <div>
        <b-row align-v="center">
          <b-col lg="3" sm="5">
            <b-form-input
              v-model="aranan"
              id="smallInput"
              @keyup.enter="getResimList"
              placeholder="Stok No/Adı/Resim Grubu"
            />
          </b-col>
          <b-col lg="3" sm="5">
            <v-select
              v-model="secilen"
              :options="filtreList"
              placeholder="İçeren"
              style=""
              @input="getResimList()"
            >
            </v-select>
          </b-col>
          <b-col lg="2" sm="5">
            <vs-button
              style="border-radius: 5px; width: 100%"
              type="gradient"
              @click="getResimList"
              id="button-with-loading-yeni"
              class="vs-con-loading__container"
              >Listele</vs-button
            >
          </b-col>
        </b-row>
      </div>
    </vs-card>
    <div>
      <b-row>
        <b-col lg="4" sm="6" :key="index" v-for="(item, index) in resimlerList">
          <vs-card>
            <b-row>
              <h6 style="color: #7367f0">{{ item.STOCKNO }}</h6>

              <h5 style="color: #7367f0">{{ item.STOCKNAME }}</h5>
              <b-col>
                <img
                  style="width: 100%"
                  :src="cevir(item.STOCKPICTURE)"
                  class="grid-view-img px-4"
                />
              </b-col>
              <b-col>
                <b-row>
                  <b-form-group
                    style="color: #000; text-align: left"
                    label="Resim Türü"
                    label-for="v-first-name"
                  >
                    <v-select
                      :value="item.GROUPCODE"
                      id="selected"
                      placeholder="İşlem"
                      label="text"
                      :options="options"
                      @input="(GROUPCODE) => updateGROUPCODE(item, GROUPCODE)"
                    />
                  </b-form-group>
                </b-row>
                <b-row>
                  <b-form-group
                    style="color: #000; text-align: left"
                    label="Kategori"
                    label-for="v-first-name"
                  >
                    <v-select
                      :value="item.SPECCODE_KATEGORIU"
                      id="selected"
                      placeholder="Kategori"
                      label="CODE"
                      :options="kategori"
                      @input="
                        (SPECCODE_KATEGORIU) =>
                          updateSPECCODE_KATEGORIU(item, SPECCODE_KATEGORIU)
                      "
                    />
                  </b-form-group>
                </b-row>
                <b-row>
                  <b-form-group
                    style="color: #000; text-align: left"
                    label="Alt Kategori"
                    label-for="v-first-name"
                  >
                    <v-select
                      :value="item.SPECCODE_KATEGOR_ALTU"
                      id="selected"
                      placeholder="Alt Kategori"
                      label="CODE"
                      :options="altkategori"
                      @input="
                        (SPECCODE_KATEGOR_ALTU) =>
                          updateSPECCODE_KATEGOR_ALTU(
                            item,
                            SPECCODE_KATEGOR_ALTU
                          )
                      "
                    />
                  </b-form-group>
                </b-row>
              </b-col>
            </b-row>
          </vs-card>
        </b-col>
      </b-row>
      <b-badge> </b-badge>
    </div>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import vSelect from "vue-select";
import { BFormSelect, BFormGroup } from "bootstrap-vue";
export default {
  data() {
    return {
      ITEMNO: "",
      secilendeger: "",
      stokId: "",
      degisen: "",
      resimlerList: [],
      kategori: [],
      altkategori: [],
      secilen: "",
      filtreList: ["İçeren", "Başlayan", "Biten"],
      aranan: "",
      selected: null,

      options: [
        { value: "a", text: "Ön Görünüm" },
        { value: "b", text: "Üst Görünüm" },
        { value: "c", text: "Yan Görünüm" },
        { value: "d", text: "Teknik Resim" },
        { value: "a", text: "Final Kontrol" },
        { value: "b", text: "Resim2" },

        { value: "a", text: "Ön Görünüm2" },
        { value: "b", text: "Üst Görünüm2" },
        { value: "c", text: "Yan Görünüm2" },
        { value: "d", text: "Teknik Resim2" },
        { value: "a", text: "Final Kontrol2" },
        { value: "b", text: "Resim3" },

        { value: "a", text: "Ön Görünüm3" },
        { value: "b", text: "Üst Görünüm3" },
        { value: "c", text: "Yan Görünüm3" },
        { value: "d", text: "Teknik Resim3" },
        { value: "a", text: "Final Kontrol3" },
      ],
    };
  },
  components: {
    BFormGroup,
    "v-select": vSelect,
    BFormSelect,
  },
  methods: {
    updateSPECCODE_KATEGOR_ALTU(item, SPECCODE_KATEGOR_ALTU) {
      item.SPECCODE_KATEGOR_ALTU = SPECCODE_KATEGOR_ALTU;
      this.degisen = "";
      this.secilendeger = SPECCODE_KATEGOR_ALTU.CODE;
      this.stokId = item.STOCKID;
      this.ITEMNO = item.ITEMNO;
      this.updateStok();
    },
    updateSPECCODE_KATEGORIU(item, SPECCODE_KATEGORIU) {
      item.SPECCODE_KATEGORIU = SPECCODE_KATEGORIU;
      this.degisen = "Kategori";
      this.secilendeger = SPECCODE_KATEGORIU.CODE;
      this.stokId = item.STOCKID;
      this.ITEMNO = item.ITEMNO;

      this.updateStok();
    },
    updateGROUPCODE(item, GROUPCODE) {
      item.GROUPCODE = GROUPCODE;
      this.degisen = "TUR";
      this.secilendeger = GROUPCODE.text;
      this.stokId = item.STOCKID;
      this.ITEMNO = item.ITEMNO;

      this.updateStok();
    },
    updateStok() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        degisen: vm.degisen,
        secilen: vm.secilendeger,
        id: vm.stokId,
        item: vm.ITEMNO,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.INT_Ls_Stock_Changed(args, function (err, result) {
          if (result.INT_Ls_Stock_ChangedResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Ls_Stock_ChangedResult);
            if (vm.veriler.response == "Ok") {
              vm.getResimList();
              vs.notify({
                title: "Başarılı",
                text: "Stok güncellemesi başarılı.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } else {
              vs.notify({
                title: "Uyarı",
                text: "Stok güncellemede hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            }
          } catch (error) {
            vs.notify({
              title: "Hata",
              text: "Stok güncellemede hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    cevir(data) {
      var srcBase64 = "data:image/jpeg;base64," + btoa(atob(data));
      return srcBase64;
    },
    getKategoriler() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.INT_Ls_Stock_Kategori(args, function (err, result) {
          if (result.INT_Ls_Stock_KategoriResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Ls_Stock_KategoriResult);
            if (vm.veriler.response == "Ok") {
              vm.kategori = vm.veriler.jsonData.categories;
              vm.altkategori = vm.veriler.jsonData.altcategories;
            } else {
              vs.notify({
                title: "Uyarı",
                text: "Kategori getirmede hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            }
          } catch (error) {}
        });
      });
    },
    getResimList() {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });

      if (vm.secilen == "") vm.secilen = "İçeren";
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        aranan: vm.aranan,
        filtre: vm.secilen,
      };
      soap.createClient(url, function (err, client) {
        client.INT_Ls_Stock_ResimList(args, function (err, result) {
          if (result.INT_ACTLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Ls_Stock_ResimListResult);
            if (vm.veriler.response == "Ok") {
              var list = JSON.parse(vm.veriler.jsonData);

              vm.resimlerList = list;
              console.log(list);
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            } else {
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          } catch (error) {
            vs.notify({
              title: "Hata",
              text: "Liste getirilirken hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          }
        });
      });
    },
  },
  created() {
    // this.getResimList();
    this.getKategoriler();
  },
};
</script>
<style lang="scss">
.vs__selected-options {
  display: contents;
}
</style>